import ErrorOutlined from "@mui/icons-material/ErrorOutlineOutlined";

import { makeSvgIcon } from "./svg-icon";

export const ErrorOutlineIcon = makeSvgIcon(
  ErrorOutlined,
  (theme) => theme.palette.error.main,
);

export default ErrorOutlineIcon;
